import * as XLSX from 'xlsx';

// export const handleFileUpload = (file, validateData, setShow) => {
// 	const reader = new FileReader();
// 	reader.onload = (e) => {
// 		try {
// 			const data = e.target.result;
// 			const workbook = XLSX.read(data, { type: 'array' });
// 			const sheetName = workbook.SheetNames[0];
// 			const sheet = workbook.Sheets[sheetName];
// 			const Data = XLSX.utils.sheet_to_json(sheet);
// 			// Process 'excelData' as needed
// 			message.success('Excel file processed successfully.');

// 			validateData(Data);
// 			setShow(true);
// 		} catch (error) {
// 			console.error('Error processing Excel file:', error);
// 			message.error('Error processing Excel file.');
// 		}
// 	};

// 	reader.readAsArrayBuffer(file);
// };

export const handleFileUpload = (file, validateData, setShow, messageApi) => {
	const reader = new FileReader();
	reader.onload = (e) => {
		try {
			const data = e.target.result;
			const workbook = XLSX.read(data, { type: 'array' });
			const sheetName = workbook.SheetNames[0];
			const sheet = workbook.Sheets[sheetName];

			// --- START: NEW ROBUST CODE ---
			// 1. Get the range of the sheet
			const range = XLSX.utils.decode_range(sheet['!ref']);
			let lastColumn = -1;

			// 2. Find the last column with a header in the first row (row 0)
			for (let C = range.s.c; C <= range.e.c; ++C) {
				const cellAddress = XLSX.utils.encode_cell({ r: range.s.r, c: C });
				const cell = sheet[cellAddress];
				// If the cell exists and has a value, update the last valid column
				if (cell && cell.v) {
					lastColumn = C;
				}
			}

			// 3. If we found a valid last column, update the sheet's range
			if (lastColumn > -1) {
				range.e.c = lastColumn; // e.g., Set the end column to the last one with a header
				sheet['!ref'] = XLSX.utils.encode_range(range);
			}
			// --- END: NEW ROBUST CODE ---

			// 4. Now, convert to JSON. It will only use the new, smaller range.
			const jsonData = XLSX.utils.sheet_to_json(sheet);

			if (messageApi) {
				messageApi.success('Excel file processed successfully.');
			}

			validateData(jsonData);
			setShow(true);
		} catch (error) {
			console.error('Error processing Excel file:', error);
			if (messageApi) {
				messageApi.error('Error processing Excel file.');
			}
		}
	};

	reader.readAsArrayBuffer(file);
};

export const fillEmptyCellWithEmptyString = (data) => {
	const allKeys = new Set();
	data.forEach((obj) => {
		Object.keys(obj).forEach((key) => allKeys.add(key));
	});

	// Step 2: Fill missing keys with empty string
	const filledData = data.map((obj) => {
		const filledObj = {};
		allKeys.forEach((key) => {
			filledObj[key] = key in obj ? obj[key] : '';
		});
		return filledObj;
	});

	return filledData;
};

export const handleFileUploadWithDefaultHeader = (file, validateData, setShow, defaultHeader, messageApi) => {
	const reader = new FileReader();

	reader.onload = (e) => {
		try {
			const data = e.target.result;
			const workbook = XLSX.read(data, { type: 'array' });
			const sheetName = workbook.SheetNames[0];
			const sheet = workbook.Sheets[sheetName];
			const Data = XLSX.utils.sheet_to_json(sheet, {
				header: defaultHeader,
				range: 1,
				defval: '',
			});

			// Process 'excelData' as needed
			messageApi.success('Excel file processed successfully.');

			validateData(Data);
			setShow(true);
		} catch (error) {
			console.error('Error processing Excel file:', error);
			messageApi.error('Error processing Excel file.');
		}
	};

	reader.readAsArrayBuffer(file);
};

export const handleFileUploadAOA = (file, validateData, setShow, messageApi) => {
	const reader = new FileReader();
	reader.onload = (e) => {
		try {
			const data = new Uint8Array(e.target.result);
			const workbook = XLSX.read(data, { type: 'array' });

			const sheetName = workbook.SheetNames[0];
			const worksheet = workbook.Sheets[sheetName];
			const aoa = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
			// Process 'excelData' as needed
			messageApi.success('Excel file processed successfully.');

			validateData(aoa);
			setShow(true);
		} catch (error) {
			console.error('Error processing Excel file:', error);
			messageApi.error('Error processing Excel file.');
		}
	};

	reader.readAsArrayBuffer(file);
};

export const exportExcelFile = (exportData, fileName) => {
	const ws = XLSX.utils.json_to_sheet(exportData);
	const columnWidths = [{ wch: 20 }, { wch: 20 }, { wch: 20 }, { wch: 20 }];
	ws['!cols'] = columnWidths;
	const wb = XLSX.utils.book_new();
	XLSX.utils.book_append_sheet(wb, ws, 'My Sheet');
	const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
	const blob = new Blob([wbout], { type: 'application/octet-stream' });
	const url = window.URL.createObjectURL(blob);
	const anchor = document.createElement('a');
	anchor.href = url;
	anchor.download = fileName;
	anchor.click();
	window.URL.revokeObjectURL(url);
};

export const exportExcelFileWithDropdowns = async (exportData, fileName, dropdowns = {}, options = {}) => {
	const { sheetName = 'My Sheet', maxRows = 200, dropdownSheetName = 'DropdownOptions', lookupTables = [] } = options;
	const ExcelJS = (await import('exceljs')).default;
	const workbook = new ExcelJS.Workbook();
	const worksheet = workbook.addWorksheet(sheetName);
	const dropdownWorksheet = workbook.addWorksheet(dropdownSheetName, { state: 'veryHidden' });

	const columns = Object.keys(exportData?.[0] || {});
	worksheet.columns = columns.map((key) => ({ header: key, key, width: Math.max(14, key.length + 2) }));

	(exportData || []).forEach((row) => {
		worksheet.addRow(row);
	});

	let dropdownColumnIndex = 1;
	Object.entries(dropdowns || {}).forEach(([columnName, rawValues]) => {
		const values = Array.from(new Set((rawValues || []).map((item) => (item ?? '').toString().trim()).filter((item) => item !== '')));
		if (values.length === 0) return;

		const columnIndex = columns.indexOf(columnName) + 1;
		if (!columnIndex) return;

		dropdownWorksheet.getCell(1, dropdownColumnIndex).value = columnName;
		values.forEach((value, valueIndex) => {
			dropdownWorksheet.getCell(valueIndex + 2, dropdownColumnIndex).value = value;
		});

		const dropdownColumnLetter = dropdownWorksheet.getColumn(dropdownColumnIndex).letter;
		const sheetReference =
			dropdownSheetName.includes(' ') || dropdownSheetName.includes("'") ? `'${dropdownSheetName.replace(/'/g, "''")}'` : dropdownSheetName;
		const formula = `${sheetReference}!$${dropdownColumnLetter}$2:$${dropdownColumnLetter}$${values.length + 1}`;
		for (let row = 2; row <= maxRows; row += 1) {
			const cell = worksheet.getCell(row, columnIndex);
			cell.dataValidation = {
				type: 'list',
				allowBlank: true,
				showErrorMessage: true,
				formulae: [formula],
			};
		}

		dropdownColumnIndex += 1;
	});

	lookupTables.forEach((tableConfig, tableIndex) => {
		const { sheetName: lookupSheetName, sourceColumn, targetColumns = [], rows = [] } = tableConfig || {};
		if (!lookupSheetName || !sourceColumn || targetColumns.length === 0 || rows.length === 0) return;

		const lookupWorksheet = workbook.addWorksheet(lookupSheetName, { state: 'veryHidden' });
		const lookupHeaders = [sourceColumn, ...targetColumns];
		lookupHeaders.forEach((header, headerIndex) => {
			lookupWorksheet.getCell(1, headerIndex + 1).value = header;
		});

		rows.forEach((row, rowIndex) => {
			lookupHeaders.forEach((header, headerIndex) => {
				lookupWorksheet.getCell(rowIndex + 2, headerIndex + 1).value = row?.[header] ?? '';
			});
		});

		const sourceColumnIndex = columns.indexOf(sourceColumn) + 1;
		if (!sourceColumnIndex) return;

		const sourceColumnLetter = worksheet.getColumn(sourceColumnIndex).letter;
		const escapedLookupSheetName =
			lookupSheetName.includes(' ') || lookupSheetName.includes("'") ? `'${lookupSheetName.replace(/'/g, "''")}'` : lookupSheetName;
		const lookupRangeEndRow = rows.length + 1;

		targetColumns.forEach((targetColumn, targetColumnOffset) => {
			const targetColumnIndex = columns.indexOf(targetColumn) + 1;
			if (!targetColumnIndex) return;

			for (let row = 2; row <= maxRows; row += 1) {
				worksheet.getCell(row, targetColumnIndex).value = {
					formula: `IFERROR(VLOOKUP($${sourceColumnLetter}${row},${escapedLookupSheetName}!$A$2:$${String.fromCharCode(
						65 + lookupHeaders.length - 1
					)}$${lookupRangeEndRow},${targetColumnOffset + 2},FALSE),"")`,
				};
			}
		});
	});

	const buffer = await workbook.xlsx.writeBuffer();
	const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
	const url = window.URL.createObjectURL(blob);
	const anchor = document.createElement('a');
	anchor.href = url;
	anchor.download = fileName;
	anchor.click();
	window.URL.revokeObjectURL(url);
};

export const exportWithData = (exportData, fileName, columnsToExport) => {
	const dataToExport = exportData.map((item) => {
		const filteredItem = {};
		columnsToExport?.forEach((col) => {
			filteredItem[col] = item[col] || '';
		});
		return filteredItem;
	});
	const wb = XLSX.utils.book_new();
	const ws = XLSX.utils.json_to_sheet(dataToExport);
	XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
	XLSX.writeFile(wb, fileName);
};
